module.exports = __webpack_public_path__ + "img/BE0708865310.ac5c9e04.svg";